import { Button, ButtonVariant, ClickEvent, Panel } from "@mcleod/components";
import { OverviewDetailProps } from "./OverviewDetailProps";
import { Alignment } from "@mcleod/core";
import { ImageName } from "@mcleod/images";

export class OverviewDetailPanel extends Panel {
    private readonly overviewSection: Panel;
    private readonly detailSection: Panel;
    private readonly overviewLocation: Alignment.TOP | Alignment.BOTTOM;
    private readonly caretColor: string;
    private _caretPanel: Panel;
    private _caret: Button;
    private isDetailDisplaying: boolean = false;

    constructor(props: OverviewDetailProps) {
        super({ padding: 0, fillRow: true });

        this.overviewLocation = props.overviewLocation;
        this.caretColor = props.chevronColor;

        props.overviewPanel.setProps({ fillRow: true, rowBreak: false });
        props.detailPanel.setProps({ fillRow: true });

        this.overviewSection = new Panel({ padding: 0, fillRow: true, rowBreak: true });
        this.overviewSection.addClickListener(() => this.toggleDetail());
        this.overviewSection.add(props.overviewPanel, this.caretPanel);

        this.detailSection = new Panel({ padding: 0, height: 0, visible: false, fillRow: true, rowBreak: true });
        this.detailSection.addClickListener(() => this.toggleDetail());
        this.detailSection.add(props.detailPanel);

        if (this.overviewLocation === Alignment.TOP) {
            this.add(this.overviewSection, this.detailSection);
        } else {
            this.add(this.detailSection, this.overviewSection);
        }
    }

    private get caretPanel(): Panel {
        if (this._caretPanel == null) {
            this._caretPanel = new Panel({ paddingLeft: 0, paddingRight: 0 });
            this._caret = new Button({
                padding: 0,
                margin: 4,
                variant: ButtonVariant.round,
                imageName: ImageName.chevron,
                imageRotation: this.overviewLocation === Alignment.TOP ? 0 : 180,
                imageColor:this.caretColor,
                onClick: () => this.toggleDetail()
            });
            this._caretPanel.add(this._caret);
        }
        return this._caretPanel;
    }

    public toggleDetail() {
        if (this.isDetailDisplaying) {
            this.detailSection.setProps({ height: 0, visible: false });
            this._caret.setProps({
                imageName: ImageName.chevron,
                imageRotation: this.overviewLocation === Alignment.TOP ? 0 : 180
            });
        } else {
            this.detailSection.setProps({ height: null, visible: true });
            this._caret.setProps({
                imageName: ImageName.chevron,
                imageRotation: this.overviewLocation === Alignment.TOP ? 180 : 0
            });
        }
        this.isDetailDisplaying = !this.isDetailDisplaying;
    }
}
